module.exports = __webpack_public_path__ + "static/img/header-top-wave.faec091.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/header-top-wave.png
// module id = 248
// module chunks = 11